import { action } from 'mobx';
import { FilterState } from '@config/DisturbanceFilter';
import { Disturbance, DisturbanceTableRows, DisturbanceType, DisturbanceTabs } from '@config/DisturbanceConfig';
import API, { DISTURBANCE_BASE_URL } from '@util/ApiUtil';

export default class DisturbanceApi {
  private static async getResults(url: string, offset: number, filter: FilterState): Promise<DisturbanceTableRows> {
    const results = await API.get(url, { params: { offset, ...filter } });
    return results.data;
  }

  private static async getTabResults(url: string, currentTab: string, filter: FilterState): Promise<DisturbanceTabs> {
    const results = await API.get(url, { params: { currentTab, ...filter } });
    return results.data;
  }

  private static async getDetailResults(url: string, disturbanceId: string): Promise<Disturbance> {
    const results = await API.get(url, { params: { disturbanceId } });
    return results.data;
  }

  private static async getDetailByIdResults(url: string, id: string, type: DisturbanceType): Promise<Disturbance> {
    const results = await API.get(url, { params: { id, atType: type } });
    return results.data;
  }

  @action
  public static getChanges = (offset: number, filter: any, authType: string): Promise<DisturbanceTableRows> => {
    return DisturbanceApi.getResults(`${DISTURBANCE_BASE_URL}/${authType}/change`, offset, filter);
  };

  @action
  public static getIncidents = (offset: number, filter: any, authType: string): Promise<DisturbanceTableRows> => {
    return DisturbanceApi.getResults(`${DISTURBANCE_BASE_URL}/${authType}/incident`, offset, filter);
  };

  @action
  public static getProblems = (offset: number, filter: any, authType: string): Promise<DisturbanceTableRows> => {
    return DisturbanceApi.getResults(`${DISTURBANCE_BASE_URL}/${authType}/problem`, offset, filter);
  };

  @action
  public static getTabs = (currentTab: string, filter: any, authType: string): Promise<DisturbanceTabs> => {
    return DisturbanceApi.getTabResults(`${DISTURBANCE_BASE_URL}/${authType}/tabs`, currentTab, filter);
  };

  @action
  public static getDisturbance = (disturbanceId: string, authType: string): Promise<Disturbance> => {
    return DisturbanceApi.getDetailResults(`${DISTURBANCE_BASE_URL}/${authType}/details`, disturbanceId);
  };

  @action
  public static getDisturbanceById = (id: string, type: DisturbanceType, authType: string): Promise<Disturbance> => {
    return DisturbanceApi.getDetailByIdResults(`${DISTURBANCE_BASE_URL}/${authType}/details-by-id`, id, type);
  };
}
